import axios from 'axios';

export const API_BASE_URL = 'https://esportofiran.ir';
// Auth endpoints use a single /api/ prefix
export const AUTH_API_URL = `${API_BASE_URL}/api`;
// All other endpoints use /api/api/
export const API_URL = `${API_BASE_URL}/api/api`;

const normalizeApiPath = (url) => {
  if (!url || url.startsWith('http')) {
    return url;
  }

  let path = url.startsWith('/') ? url.slice(1) : url;
  // Strip accidental leading api/ or api/api/ so baseURL stays authoritative
  if (path.toLowerCase().startsWith('api/api/')) {
    path = path.slice(8);
  } else if (path.toLowerCase().startsWith('api/')) {
    path = path.slice(4);
  }

  return path;
};

const axiosApi = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'text/plain',
    'Content-Type': 'application/json',
  },
});

axiosApi.interceptors.request.use(
  (config) => {
    if (config.url) {
      config.url = normalizeApiPath(config.url);
    }

    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_token_exp');
      window.location.href = '/login';
    }
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  const response = await axiosApi.get(url, { ...config });
  return response.data;
}

export async function post(url, data, config = {}) {
  const response = await axiosApi.post(url, data, { ...config });
  return response.data;
}

export async function loginAdmin(data, config = {}) {
  // Auth uses a single /api/ prefix, not /api/api/
  const response = await axios.post(`${AUTH_API_URL}/adminLogin`, data, {
    headers: {
      Accept: 'text/plain',
      'Content-Type': 'application/json',
    },
    ...config,
  });
  return response.data;
}

export async function put(url, data, config = {}) {
  const response = await axiosApi.put(url, data, { ...config });
  return response.data;
}

export async function del(url, config = {}) {
  const response = await axiosApi.delete(url, { ...config });
  return response.data;
}

export function getAllSliders() {
  return axiosApi.get('admin/getAllSliders');
}

export function activateSlider(sliderId) {
  return axiosApi.post(`admin/activateSlider/${sliderId}`);
}

export function deactivateSlider(sliderId) {
  return axiosApi.post(`admin/deactivateSlider/${sliderId}`);
}

export function deleteSlider(sliderId) {
  return axiosApi.delete(`admin/deleteSlider/${sliderId}`);
}

export function uploadSliderPicture(file) {
  const formData = new FormData();
  formData.append('file', file);
  return axiosApi.post('upload/sliderPic', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function createSlider(sliderData) {
  return axiosApi.post('admin/addSlider', sliderData);
}
